import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';
import * as repositoryActions from '../../Store/Actions/repositoryActions';
import * as globalActions from '../../Store/Actions/globalActions';
import * as sidebarActions from '../../Store/Actions/sidebarActions';

//Components GLOBAL ACTION
import Contact from '../Components/Modules/Contact/contact';
import Task from '../Components/Modules/Task/task';
import Notification from '../Components/Modules/Notification/notification';
import Login from '../Components/Modules/Login/login';

class Header extends Component {
    constructor(props) {
      super(props);
      this.state = {
        subMenuList:["Programs","Documents","Contacts","Admin"],
      };

    }
    onClickItem = (i,j) => {
      this.props.switchMenuItem(i,j);
      this.props._update_sublevel("");
    }
  
    render() {
      var submenuList = this.state.subMenuList; 
      var activeView = this.props.activeView;
      var sidebarContent = this.props.sidebarContent;
      var menuContent = submenuList.map((itemMenu,id)=>{
        return (
          <div key={id} className={activeView === itemMenu ? "menu-item active": "menu-item"} onClick={this.onClickItem.bind(this, sidebarContent.findIndex(item=>item.name ===itemMenu), 0)}>{itemMenu}</div>
        )
      });
      var clients = this.props.clients;
      var clientsContent = clients.map((item,id)=>{
        return(<option key={id}>{item}</option>)
      });
      

      return (
        <div className="Header">
          <div className="row">
            <div className="Logo"><div><FontAwesomeIcon icon="globe-europe" /><span>{this.props.appTitle}</span></div></div>
            <div className="Menu">
              <div className="selector">
                <select>
                 {clientsContent}
                </select>
              </div>
            </div>
            <div className="IconLibrary">
              {/* QUICK ACTION MODULES */}
                <Contact></Contact>
                <Task></Task>
                <Notification></Notification>
                <Login></Login>
            </div>
          </div>
          <div className="row submenu">
            {/* MENU  */}
            <div className={ this.props.activeView ==="Homepage" ? "menu-item active": "menu-item"} onClick={this.onClickItem.bind(this, this.props.sidebarContent.findIndex(item=>item.name ==="Homepage"), 0)}><FontAwesomeIcon icon="home"/></div>
            {menuContent}
            <div className="bread-crumb">{this.props.activeView}{this.props.submenu.length>0?" - "+this.props.submenu:null}</div>
          </div>
          
        </div>
      );
    }
  }
  
  const mapStateToProps = (state) => {    
    return {  
      appTitle: state.appReducer.appTitle, 
      notificationHistory : state.appReducer.notificationHistory,
      activeView: state.appReducer.activeView,
      sidebarContent: state.appReducer.sidebarContent,
      clients : state.appReducer.clients,
      submenu:state.appReducer.submenu,
    } 
  }
  const mapDispatchToProps = (dispatch) => {
    return {
      switchMenuItem: (i,j) => dispatch(sidebarActions.switchMenuItem(i,j)),
      _update_sublevel:(name) =>dispatch(globalActions.update_sublevel(name)),

     } 
  } 
  
  export default connect(mapStateToProps, mapDispatchToProps)(Header);
  